module.exports = __webpack_public_path__ + "static/flags/VC-abcc5f9fdfeb51e564d8ebe4d6901235.gif";